module.exports = __webpack_public_path__ + "img/fallback-medium-hero-01.000b9fb.jpg";